export const nationalParkingStyles = {
	header: {
		backgroundColor: '#e8e8e4',
	},
	sidebar: {
		backgroundColor: '#191b2b',
		color: 'white',
	},
	button: {
		backgroundColor: '#f58220',
		color: '#191B59',
		border: '2px solid #f58220',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#f58220',
			border: '2px solid #f58220',
			color: '#fff',
		},
	},
	outlinedButton: {
		border: '2px solid #f58220',
		':hover': {
			border: '2px solid #f58220',
		},
	},
	title: {
		color: 'black',
	},
	text: {
		color: '#191b2b',
	},
	table: {
		headerBackgroundColor: '#191b2b',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'National Parking Platform',
	},
	favicon: {
		src: '/national/national-parking-icon-white.png',
	},
	logo: {
		small: {
			// Will come from an s3 bucket eventually
			src: '/national/national-parking-icon-white.png',
			height: 30,
			width: 30,
		},
		large: {
			src: '/national/national-parking-logo-white.png',
			height: 40,
			width: 159,
		},
	},
	socials: {},
	siteUrl: 'https://national-parking.com/',
	orgName: 'National Parking',
};
